import React from 'react';
import LegalLayout from './LegalLayout';
import { COMPANY } from '../../config/company';

function Section({ title, children }) {
  return (
    <section>
      <h2 className="text-lg font-bold text-foreground mb-3 flex items-center gap-2">
        <span className="w-1.5 h-5 rounded-full bg-primary inline-block flex-shrink-0" />
        {title}
      </h2>
      <div className="pl-4 space-y-2 text-sm">{children}</div>
    </section>
  );
}

export default function MentionsLegales({ onOpenWizard }) {
  return (
    <LegalLayout title="Mentions Légales" onOpenWizard={onOpenWizard}>

      <Section title="Éditeur du site">
        <p><strong className="text-foreground">Raison sociale :</strong> {COMPANY.legalName}</p>
        <p><strong className="text-foreground">Forme juridique :</strong> Société par Actions Simplifiée (SAS)</p>
        <p><strong className="text-foreground">Capital social :</strong> {COMPANY.capitalSocial}</p>
        <p><strong className="text-foreground">SIREN :</strong> {COMPANY.siren}</p>
        <p><strong className="text-foreground">SIRET :</strong> {COMPANY.siret}</p>
        <p><strong className="text-foreground">RCS :</strong> {COMPANY.rcsCity}</p>
        <p><strong className="text-foreground">N° TVA intracommunautaire :</strong> {COMPANY.tva}</p>
        <p>
          <strong className="text-foreground">Siège social :</strong>{' '}
          <a href={COMPANY.mapsHref} target="_blank" rel="noopener noreferrer"
            className="text-primary hover:underline">
            {COMPANY.address.full}
          </a>
        </p>
        <p>
          <strong className="text-foreground">Directeur de la publication :</strong> {COMPANY.director}
        </p>
        <p>
          <strong className="text-foreground">Contact :</strong>{' '}
          <a href={COMPANY.emailHref} className="text-primary hover:underline">{COMPANY.email}</a>
        </p>
      </Section>

      <Section title="Hébergement">
        <p><strong className="text-foreground">Hébergeur :</strong> Microsoft Azure</p>
        <p><strong className="text-foreground">Adresse :</strong> Microsoft France, 37-39 Quai du Président Roosevelt, 92130 Issy-les-Moulineaux</p>
        <p><strong className="text-foreground">Site :</strong>{' '}
          <a href="https://azure.microsoft.com" target="_blank" rel="noopener noreferrer"
            className="text-primary hover:underline">azure.microsoft.com</a>
        </p>
      </Section>

      <Section title="Propriété intellectuelle">
        <p>
          L'ensemble des contenus présents sur ce site (textes, images, graphiques, logo, icônes, sons, logiciels)
          est la propriété exclusive de {COMPANY.legalName}, sauf mentions contraires.
        </p>
        <p>
          Toute reproduction, distribution, modification, adaptation, retransmission ou publication, même partielle,
          de ces différents éléments est strictement interdite sans l'accord exprès par écrit de {COMPANY.legalName}.
        </p>
      </Section>

      <Section title="Liens hypertextes">
        <p>
          Le site peut contenir des liens vers d'autres sites. {COMPANY.legalName} n'est pas responsable
          du contenu de ces sites tiers et décline toute responsabilité quant aux dommages pouvant résulter
          de leur consultation.
        </p>
      </Section>

      <Section title="Limitation de responsabilité">
        <p>
          Les informations contenues sur ce site sont aussi précises que possible. Toutefois, {COMPANY.legalName}
          ne peut garantir l'exactitude, la complétude et l'actualité des informations diffusées.
        </p>
        <p>
          {COMPANY.legalName} décline toute responsabilité pour tout dommage direct ou indirect résultant
          de l'accès au site ou de l'utilisation de son contenu.
        </p>
      </Section>

      <Section title="Droit applicable et juridiction">
        <p>
          Les présentes mentions légales sont soumises au droit français. En cas de litige,
          les tribunaux compétents seront ceux de Paris, nonobstant pluralité de défendeurs
          ou appel en garantie.
        </p>
      </Section>

    </LegalLayout>
  );
}
